import React, { useState } from 'react'
import profile from '../../img/43022.jpg';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { FaCopy } from 'react-icons/fa';
import { toast } from 'react-toastify';    
import 'react-toastify/dist/ReactToastify.css';  


const ProfileHeader = () => {

  return (
      <div className="account__profile">
          
          <div className="account__profile__ top__margin">
            <h5 className="inner__page__title">
                Your Account Profile
            </h5>
            <p>Ensure your details are up to date. 
                This helps us to provide a really great service
                and target your campaigns effectively
            </p>

            <h5 className='wallet__title'>Wallet Address</h5>
            <div className="business__wallet__address">
            <p className="address">JGJJJIOJ88RUJOJO8U07667hvhv6T7VJJ80JDJFE9R9OIJFJDF</p>
                <CopyToClipboard text="JGJJJIOJ88RUJOJO8U080JDJFE9R9OIJFJDF">
                    <span>
                      <FaCopy 
                        onClick={() => toast.success('Copied!')} 
                        className='blueColor'
                      /> 
                    </span>
                </CopyToClipboard>
            </div>  
          </div>
          <img className='api__webhook__img' src={profile} alt="profile illustrstion" />
        </div>
      
  )
}

export default ProfileHeader